import { Chip, Stack } from '@mui/material';
import { type BaseFlowBlockEventDefinition } from 'flow-schema';

import { isDefined } from 'common';

import { useStandardAnalyticEvents } from '../../../../../../../../hooks/useStandardAnalyticEvents';
import { useReactFlowViewContext } from '../../../../context/context';
import { NodeConfigTab } from '../../../../types';

import { ReactComponent as AnalyticEventSvg } from './analyticEvent.svg';

interface NodeAnalyticEventDecoratorProps {
  events?: Pick<BaseFlowBlockEventDefinition, 'id' | 'name'>[];
  nodeId: string;
}

export function NodeAnalyticEventDecorator(props: NodeAnalyticEventDecoratorProps) {
  const { events, nodeId } = props;

  const { getEventDetails } = useStandardAnalyticEvents();

  const { setBlockDrawerTab, setSelectedNodeId } = useReactFlowViewContext();

  if (!isDefined(events) || events.length === 0) {
    return null;
  }

  return (
    <Stack gap={1} alignItems="start">
      {events.map((event) => {
        const { name } = getEventDetails(event);
        return (
          <Chip
            key={event.id}
            label={name}
            icon={<AnalyticEventSvg />}
            onClick={(clickEvent) => {
              clickEvent.stopPropagation();
              setSelectedNodeId(nodeId);
              setBlockDrawerTab(NodeConfigTab.Analytics);
            }}
            aria-label={`View ${name} analytics`}
            clickable
            size="small"
          />
        );
      })}
    </Stack>
  );
}
